import { render } from "./adminEvent.vue?vue&type=template&id=64e105b6&scoped=true"
import script from "./adminEvent.vue?vue&type=script&lang=js"
export * from "./adminEvent.vue?vue&type=script&lang=js"

import "./adminEvent.vue?vue&type=style&index=0&id=64e105b6&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e105b6"]])

export default __exports__